import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const SupportIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M2.24956 12C2.24956 6.61406 6.61277 2.25 11.9977 2.25C17.3825 2.25 21.7458 6.61406 21.7458 12V18.7547C21.7458 19.7906 20.9069 20.6297 19.8711 20.6297L14.6971 20.625C14.3081 19.95 13.5817 19.5 12.7475 19.5H11.2478C10.0059 19.5 8.99824 20.5078 8.99824 21.75C8.99824 22.9922 10.0059 24 11.2478 24H12.7475C13.5817 24 14.3081 23.5453 14.6971 22.875L19.8711 22.8797C22.1488 22.8797 24 21.0328 24 18.7547V12C23.9953 5.37188 18.6245 0 11.9977 0C5.37083 0 0 5.37188 0 12V13.875C0 14.4984 0.501465 15 1.12478 15C1.7481 15 2.24956 14.4984 2.24956 13.875V12ZM7.49854 10.5V15.75C6.66901 15.75 5.99883 15.0797 5.99883 14.25V12C5.99883 11.1703 6.66901 10.5 7.49854 10.5ZM3.74927 12V14.25C3.74927 16.3219 5.42707 18 7.49854 18H8.24839C9.07791 18 9.7481 17.3297 9.7481 16.5V9.75C9.7481 8.92031 9.07791 8.25 8.24839 8.25H7.49854C5.42707 8.25 3.74927 9.92812 3.74927 12ZM16.4968 10.5C17.3263 10.5 17.9965 11.1703 17.9965 12V14.25C17.9965 15.0797 17.3263 15.75 16.4968 15.75V10.5ZM20.246 12C20.246 9.92812 18.5682 8.25 16.4968 8.25H15.7469C14.9174 8.25 14.2472 8.92031 14.2472 9.75V16.5C14.2472 17.3297 14.9174 18 15.7469 18H16.4968C18.5682 18 20.246 16.3219 20.246 14.25V12Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default SupportIcon
